import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"

export const BillingCard = styled(Flex)`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.lightest};
    border-radius: ${theme.border.radius.large};
  `}
`

export const BillingRenewal = styled(Flex)`
  ${({theme}) => css`
    background: linear-gradient(87.07deg, ${theme.colors.primary1} 1.37%, ${theme.colors.secondary1} 98.28%);
    border-radius: ${theme.border.radius.medium};
  `}
`

export const BillingChip = styled(Flex)`
  ${({theme}) => css`
    background-color: ${theme.colors.primary2};
    border-radius: ${theme.border.radius.medium};
    border: 1px solid ${theme.colors.greys.medium};
    padding: ${theme.spacing.one};
  `}
`

export const BillingInfo = styled(Flex)`
  ${({theme}) => css`
    border-top: 1px solid ${theme.colors.greys.light};
    &:last-child {
      border-bottom: 1px solid ${theme.colors.greys.light};
    }
    > p {
      flex-basis: 50%;
    }
  `}
`
